module.exports = __webpack_public_path__ + "img/workers_blue.7c950f04.svg";